module.exports = __webpack_public_path__ + "ea7ad5c004a5fa199a527a2f154398d1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-10.png
// module id = 2240
// module chunks = 0